<template>
  <div>
    <nav class="navbar navbar-expand-md navbar-light bg-transparent flex-nowrap p-0">
        <div class="collapse navbar-collapse d-none d-md-inline-blocki">
          <hr class="d-md-none"/>
          <ul class="navbar-nav mr-auto align-items-center">
            <li class="mr-3 pt-1">
              <div class="d-none d-md-inline-block">
                  <a href="https://www.facebook.com/radiokids.online/" title="facebook" target="_blank">
                    <img class="social-small" aria-hidden="true" src="/public/img/facebook.svg"/>
                  </a>
                  <a href="https://www.instagram.com/radiokids.online/" title="instagram" target="_blank">
                    <img class="social-small" aria-hidden="true" src="/public/img/instagram.svg"/>
                  </a>
              </div>
            </li>
            <router-link v-for="(item, key) in items"
                         :key="key"
                         tag="li"
                         class="nav-item text-nowrap"
                         active-class="active"
                         :to="item.path"
                         exact
            >
              <a class="nav-link" href="#">
                {{ item.title }}<span class="sr-only">(current)</span>
              </a>
            </router-link>
          </ul>
        </div>

        <div class="text-nowrap d-block d-md-none">
          <button class="navbar-toggler mr-2"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Рорзгорнути меню"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <a href="fb://radiokids.online/" title="facebook">
            <img class="social" aria-hidden="true" src="/public/img/facebook.svg"/>
          </a>
          <a href="https://www.instagram.com/radiokids.online/" title="instagram">
            <img class="social" aria-hidden="true" src="/public/img/instagram.svg"/>
          </a>
        </div>

        <div class="vertical-delimiter ml-3"></div>

        <div class="media button-block flex-nowrap">
          <div class="mr-3 ml-3">
            <PlayerButtonSmallWithoutLabel/>
          </div>
          <div class="media-body">
            <div class="mt-0 media-body-container d-md-none d-lg-block wording-first-ukrainian pr-2">
              <div class="text-nowrap"><small>Перше українське</small></div>
              <div class="text-nowrap"><small>дитяче онлайн радіо</small></div>
            </div>
          </div>
        </div>
    </nav>

    <nav class="navbar navbar-expand-md navbar-light bg-transparent d-block d-md-none">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <hr>
        <ul class="navbar-nav mr-auto">
          <router-link v-for="(item, key) in items"
                       :key="key"
                       tag="li"
                       class="nav-item"
                       active-class="active"
                       :to="item.path"
                       exact
                       v-on:click.native="collapseMenu"
          >
            <a class="nav-link" href="#">
              {{ item.title }}<span class="sr-only">(current)</span>
            </a>
          </router-link>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import PlayerButtonSmallWithoutLabel from '@/components/PlayerButtonSmall/PlayerButtonSmallWithoutLabel'

const MenuItems = {
  'home': {
    'path': '/',
    'title': 'Головна'
  },
  'about-us': {
    'path': '/about-us',
    'title': 'Про нас'
  },
  'timetable': {
    'path': '/timetable',
    'title': 'Програма передач'
  },
  'speakers': {
    'path': '/speakers',
    'title': 'Наші диктори'
  },
  'partners': {
    'path': '/partners',
    'title': 'Партнери'
  },
  'cooperation': {
    'path': '/cooperation',
    'title': 'Співпраця'
  }
}
export default {
  name: 'Navigation',
  components: {
    PlayerButtonSmallWithoutLabel
  },
  data () {
    return {
      items: MenuItems
    }
  },
  methods: {
    collapseMenu () {
      document.querySelector('#navbarSupportedContent').classList.remove('show')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../variables.scss';

  .navbar-big-viewport .nav-item.disabled > .nav-link {
    color: #6c757d;
  }
  .button-block {
    align-items: center;
  }
  .nav-item:not(.active) .nav-link {
    color: deepskyblue;
  }
  .vertical-delimiter {
    height: 40px;
    border-right: 1px solid rgba(0,0,0,.1);
  }
  .social {
    width: 35px;
  }
  .social-small {
    width: 30px;
  }
  .nav-item:not(.active) .nav-link {
    color: darkorange;
  }

  @media only screen and (max-width: $width-to-show-right-wordings - 1) {
    .wording-first-ukrainian {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/Navigation.vue